import { Link } from 'react-router-dom';
import logoFull from '../../images/pd-logo-white.png';
import logoPWhite from '../../images/logo/pd-logomark-white.png';
import React from 'react';

export const DesktopSidebarLogo = ({ isOpen }) => (
  <Link to={'/'}>
    <div className={`flex p-2 ${isOpen ? 'ml-4 self-start pl-5' : 'justify-center self-center'}`}>
      {isOpen ? (
        <img alt="Pure Desire Ministries" src={logoFull} className="text-pdwhite h-20" />
      ) : (
        <img alt="Pure Desire Ministries" src={logoPWhite} className="text-pdwhite mt-3 h-12" />
      )}
    </div>
  </Link>
);
